var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarthinsmooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 0C8.55464 4.35194 12.0465 7.8438 16.3984 8C12.0465 8.1562 8.55464 11.6481 8.39844 16C8.24224 11.6481 4.75037 8.1562 0.398438 8C4.75037 7.8438 8.24224 4.35194 8.39844 0Z",
    fill: "#FAB73B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarthinsmooth);
export default __webpack_public_path__ + "static/media/starthinsmooth.f5a4522e7c826e7fd30380421ff24580.svg";
export { ForwardRef as ReactComponent };